import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import ReactHtmlParser from 'react-html-parser';

const HomeContact = (props) => (
    <section id="highlight-contact" className="highlight-with-images">
        <div className="row">
            <div className="col col-images col-12 col-lg-5">
                <Fade top>
                    <div className="image image-1 front top right">
                        {props.widgets.bloc3_image1 &&
                            <img src={props.widgets.bloc3_image1.data.url} alt=""/>
                        }
                    </div>
                </Fade>
                <Fade bottom>
                    <div className="image image-2 back bottom left">
                        {props.widgets.bloc3_image2 &&
                            <img src={props.widgets.bloc3_image2.data.url} alt=""/>
                        }
                    </div>
                </Fade>
            </div>
            <div className="col col-content col-12 col-lg-5 offset-0 offset-lg-1 align-self-center mt-md-50">
                {props.widgets.bloc3_titre &&
                    <h3>{ReactHtmlParser(props.widgets.bloc3_titre.data.content)}</h3>
                }
                {props.widgets.bloc3_contenu &&
                    <div className="content">{ReactHtmlParser(props.widgets.bloc3_contenu.data.content)}</div>
                }
                {props.widgets.bloc3_bouton &&
                    <Button variant="contained" color="primary" className="btn-more" component={props => <Link to="/page/pedagogie" {...props}/>}>
                        {props.widgets.bloc3_bouton.data.content}
                    </Button>
                }
            </div>
        </div>
    </section>
);

HomeContact.propTypes = {
    widgets: PropTypes.object.isRequired,
};

export default HomeContact;



// WEBPACK FOOTER //
// ./src/features/Home/components/HomeContact.js